export const RTD: React.FC<{
  children: React.ReactNode | React.ReactNode[];
}> = props => {
  return <td style={{ textAlign: 'right' }}>{props.children}</td>;
};
